import { Record } from 'immutable';

export default class CompetencyRecord extends Record({
  id: null,
  name: null,
  level: null,
  path: null,
  is_active: true,
  is_system: false,
  parent: undefined,
  children: undefined,
  external_mappings: undefined,
  staffing_company_group_id: null,
  links: undefined,
}) {
}
